<div (window:beforeunload)="beforeUnload()"></div>
<div class="layout-wrapper" [ngClass]="{'p-input-filled': app.inputStyle === 'filled', 'p-ripple-disabled': !app.ripple,
        'layout-menu-static': isStatic(),
        'layout-menu-overlay': isOverlay(),
        'layout-menu-horizontal': isHorizontal(),
        'layout-menu-slim': isSlim(),
        'layout-menu-active': menuActive,
        'layout-menu-mobile-active': mobileMenuActive,
        'layout-topbar-mobile-active': mobileTopbarActive,
        'layout-rightmenu-active': rightMenuActive,
        'layout-rtl': app.isRTL}" [class]="'layout-menu-' + app.menuTheme + ' layout-topbar-' + app.topbarTheme">
    <app-spinner></app-spinner>
    <app-topbar [user]="user"></app-topbar>

    <div class="banner"></div>
    <div *ngIf="user">
        <app-breadcrumb></app-breadcrumb>
    </div>
    <div class="layout-main">
        <div class="layout-content">
            <div class="p-grid">
                <div class="p-xl-2"></div>
                <div class="p-xl-7 p-lg-12 p-md-12 p-sm-12">
                    <p-messages [(value)]="msgs"></p-messages>
                    <router-outlet></router-outlet>
                </div>
                <div class="p-xl-2"></div>
            </div>
        </div>


        <app-footer></app-footer>
    </div>

    <!--<app-config></app-config>-->

    <div *ngIf="mobileMenuActive" class="layout-mask modal-in"></div>

</div>
